webpackJsonp([17],{

/***/ 1306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCreditForm_vue__ = __webpack_require__(3074);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_232bbcfa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCreditForm_vue__ = __webpack_require__(5753);
function injectStyle (ssrContext) {
  __webpack_require__(5746)
  __webpack_require__(5748)
  this["$style"] = __webpack_require__(5750)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-232bbcfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCreditForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_232bbcfa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCreditForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTagTable_vue__ = __webpack_require__(3077);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5258dfb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTagTable_vue__ = __webpack_require__(5760);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTagTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5258dfb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTagTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 3074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_credit_rules_js__ = __webpack_require__(5752);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_1__user_credit_rules_js__["a" /* formRules */],
      loading: false,
      form: {
        userid: this.$route.params.userid,
        credit: '',
        desc: '',
        projectid: ''
      },
      projectInfo: []
    };
  },

  computed: {},
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLoad: function onLoad() {},
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.onLoad();
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.update();
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    update: function update() {
      var _this2 = this;

      request.common('updateUserCredit', this.form).then(function (res) {
        _this2.$confirm(_this2.$route.meta.title + '成功, 是否继续？', '提示', { type: 'success' }).then(function () {
          _this2.$refs.form.resetFields();
        }, function () {
          _this2.$router.push({ path: '/users/table/' });
        });
      });
    },
    remoteMethod: function remoteMethod(query) {
      var _this3 = this;

      if (query !== '') {
        this.loading = true;
        setTimeout(function () {
          request.alert('getProjectName', { keyword: query }).then(function (_ref) {
            var data = _ref.data;

            _this3.projectInfo = data;
            _this3.loading = false;
          });
        }, 500);
      }
    }
  }
});

/***/ }),

/***/ 3077:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_mixins_table__ = __webpack_require__(1346);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__core_mixins_table__["b" /* default */]],
  data: function data() {
    return {
      search: {
        tag_id: null,
        keyword: null,
        exclusive: null,
        is_group: null
      },
      table: []
    };
  },

  methods: {
    getTableData: function getTableData(params) {
      return request.page('getUserTagTable', params);
    },
    onDelete: function onDelete(id) {
      var _this = this;

      this.$confirm('你确定要删除该用户标签吗？', '警告').then(function (_) {
        request.common('deleteUsertag', { id: id }).then(function (_) {
          _this.$message.success('删除成功！');
          _this.onSearch();
        });
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
});

/***/ }),

/***/ 3078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userTag_rules_js__ = __webpack_require__(5761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_api_request__ = __webpack_require__(154);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// 引入request模块


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      id: 0,
      formRules: __WEBPACK_IMPORTED_MODULE_2__userTag_rules_js__["a" /* formRules */],
      form: {
        id: 0,
        tagname: '',
        tagdesc: '',
        has_tag_ids: [],
        belong_group_ids: [],
        is_group: '0'
      },
      tag_type_options: [{
        value: '0',
        label: '普通标签'
      }, {
        value: '1',
        label: '标签组'
      }]
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__core_api_request__["default"].map(['getUserTagTable', 'getUserTagDetail']), {
    onTagTypeChange: function onTagTypeChange() {
      // 当标签类型改变时，重置相关字段
      this.form.has_tag_ids = [];
      this.form.belong_group_ids = [];
      this.form.exclusive = '0';
    },
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__core_api_request__["default"].page('getUserTagDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this.form = data;
        if (!_this.form.belong_group_ids) {
          _this.$set(_this.form, 'belong_group_ids', []);
        }
        if (!_this.form.has_tag_ids) {
          _this.$set(_this.form, 'has_tag_ids', []);
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var form = _this2.form;
          _this2.id ? _this2.update(_this2.id, form) : _this2.create(form);
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    create: function create(form) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__core_api_request__["default"].common('createUsertag', form).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this3.$refs.form.resetFields();
        }, _this3.backToList);
      });
    },
    update: function update(id, form) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__core_api_request__["default"].common('updateUsertag', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, form)).then(function (res) {
        _this4.$confirm(_this4.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(_this4.backToList);
      });
    },
    backToList: function backToList() {
      this.$router.push({ path: '/usertag/table/' });
    }
  })
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTagForm_vue__ = __webpack_require__(3078);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b9a369_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTagForm_vue__ = __webpack_require__(5762);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTagForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b9a369_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTagForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5746:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5747);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0e534be4", content, true, {});

/***/ }),

/***/ 5747:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserCreditForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5748:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5749);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("994356ec", content, true, {});

/***/ }),

/***/ 5749:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserCreditForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5750:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5751);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("51fd97da", content, true, {});

/***/ }),

/***/ 5751:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserCreditForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])())]
};

var formRules = {
  credit: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入金额，只允许输入数字', 'number'))],
  userids: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请至少添加一个用户', 'string'))],
  projectid: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择项目', 'number'))]
};

/***/ }),

/***/ 5753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/users/table"}},[_vm._v("用户列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("赏金增加/减少")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"金额","prop":"credit"}},[_c('el-input',{model:{value:(_vm.form.credit),callback:function ($$v) {_vm.$set(_vm.form, "credit", $$v)},expression:"form.credit"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"原因","prop":"desc"}},[_c('el-input',{model:{value:(_vm.form.desc),callback:function ($$v) {_vm.$set(_vm.form, "desc", $$v)},expression:"form.desc"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名","prop":"projectid"}},[_c('el-select',{attrs:{"filterable":"","remote":"","reserve-keyword":"","clearable":"","placeholder":"请输入关键词","remote-method":_vm.remoteMethod,"loading":_vm.loading},model:{value:(_vm.form.projectid),callback:function ($$v) {_vm.$set(_vm.form, "projectid", $$v)},expression:"form.projectid"}},_vm._l((_vm.projectInfo),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading",staticStyle:{"position":"relative"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户标签管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"标签ID","prop":"tag_id"}},[_c('el-input',{attrs:{"placeholder":"请输入标签id","clearable":""},model:{value:(_vm.search.tag_id),callback:function ($$v) {_vm.$set(_vm.search, "tag_id", $$v)},expression:"search.tag_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"标签名","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"模糊搜索标签名称","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否排他","prop":"exclusive"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择是否排他","clearable":""},model:{value:(_vm.search.exclusive),callback:function ($$v) {_vm.$set(_vm.search, "exclusive", $$v)},expression:"search.exclusive"}},_vm._l(([{label: '是', value: '1'}, {label: '否', value: '0'}]),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否标签组","prop":"is_group"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择是否标签组","clearable":""},model:{value:(_vm.search.is_group),callback:function ($$v) {_vm.$set(_vm.search, "is_group", $$v)},expression:"search.is_group"}},_vm._l(([{label: '是', value: '1'}, {label: '否', value: '0'}]),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetForm('searchForm')}}},[_vm._v("重置\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('router-link',{attrs:{"to":'/usertag/create'}},[_c('el-button',{attrs:{"type":"success","size":"mini"}},[_vm._v(" 添加标签\n        ")])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"标签ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tagname","label":"标签名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"exclusive","label":"是否排他"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.exclusive === '1' ? '是' : '否')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_group","label":"是否标签组"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.is_group === '1' ? '是' : '否')+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tagdesc","label":"标签描述"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":'/usertag/update/'+scope.row.id}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("修改\n            ")])],1),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onDelete(scope.row.id)}}},[_vm._v("删除\n          ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_rule__ = __webpack_require__(1345);



var formRules = {
  tagname: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utils_rule__["a" /* makeRule */])('请输入标签名称')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utils_rule__["a" /* makeRule */])('请输入1-20个字符', 'string'), { min: 1, max: 20 })]
};

/***/ }),

/***/ 5762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading",staticStyle:{"position":"relative"}},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("用户标签管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{key:"is_group",attrs:{"label":"标签类型","prop":"is_group"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","disabled":_vm.id > 0},on:{"change":_vm.onTagTypeChange},model:{value:(_vm.form.is_group),callback:function ($$v) {_vm.$set(_vm.form, "is_group", $$v)},expression:"form.is_group"}},_vm._l((_vm.tag_type_options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{key:"tagname",attrs:{"label":"标签名称","prop":"tagname"}},[_c('el-input',{model:{value:(_vm.form.tagname),callback:function ($$v) {_vm.$set(_vm.form, "tagname", $$v)},expression:"form.tagname"}})],1),_vm._v(" "),(_vm.form.is_group === '0')?_c('el-form-item',{attrs:{"label":"是否排他","prop":"exclusive"}},[_c('el-switch',{attrs:{"active-value":"1","inactive-value":"0"},model:{value:(_vm.form.exclusive),callback:function ($$v) {_vm.$set(_vm.form, "exclusive", $$v)},expression:"form.exclusive"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{key:"tagdesc",attrs:{"label":"标签说明","prop":"tagdesc"}},[_c('el-input',{model:{value:(_vm.form.tagdesc),callback:function ($$v) {_vm.$set(_vm.form, "tagdesc", $$v)},expression:"form.tagdesc"}})],1),_vm._v(" "),(_vm.form.is_group === '0')?_c('el-form-item',{key:"belong_group_ids",attrs:{"label":"关联标签组","prop":"belong_group_ids"}},[_c('remote-select',{staticClass:"width-max",attrs:{"multiple":"","clearable":"","id-key":"id","keyword-key":"keyword","label-key":"tagname","value-key":"id","placeholder":"请输入标签组名称","query-request":_vm.getUserTagTable,"query-params":{is_group: '1'},"find-request":_vm.getUserTagDetail},model:{value:(_vm.form.belong_group_ids),callback:function ($$v) {_vm.$set(_vm.form, "belong_group_ids", $$v)},expression:"form.belong_group_ids"}})],1):_vm._e(),_vm._v(" "),(_vm.form.is_group === '1')?_c('el-form-item',{key:"has_tag_ids",attrs:{"label":"子标签","prop":"has_tag_ids"}},[_c('remote-select',{staticClass:"width-max",attrs:{"multiple":"","clearable":"","id-key":"id","keyword-key":"keyword","label-key":"tagname","value-key":"id","placeholder":"请输入标签名称","query-request":_vm.getUserTagTable,"query-params":{is_group: '0'},"find-request":_vm.getUserTagDetail},model:{value:(_vm.form.has_tag_ids),callback:function ($$v) {_vm.$set(_vm.form, "has_tag_ids", $$v)},expression:"form.has_tag_ids"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n            ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user-credit-form.088a8d0f9cc100de88ef.js